// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3pclX","errors":"Errors_errors__3kokK"};